import script from "./bulk-tag-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./bulk-tag-panel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__